/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { OnboardingDatapoint } from "./OnboardingDatapoint";
export const OnboardingDatapointsResponse = core.serialization.object({
    data: core.serialization.list(OnboardingDatapoint),
});
